module.exports = __webpack_public_path__ + "static/media/applications-mobile.eddebd71.svg";